import BaseEmberTooltip from 'ember-tooltips/components/ember-tooltip';

// Class ember-tooltips puts on the tooltip while it is shown, removed as soon as hiding starts
const SHOWN_CLASS = 'ember-tooltip-show';

export default class EmberTooltip extends BaseEmberTooltip {
  // Setting defaults for ember-tooltips
  // Popper.js documentation: https://popper.js.org/docs/v1/
  popperContainer = 'body';

  popperOptions = {
    modifiers: {
      preventOverflow: {
        enabled: true,
        boundariesElement: 'viewport',
        priority: ['left', 'right', 'bottom', 'top'],
        escapeWithReference: false,
      },
    },
  };

  private get isOpen(): boolean {
    return Boolean(
      this._tooltip?.popperInstance?.popper.classList.contains(SHOWN_CLASS),
    );
  }

  // ember-tooltips writes its own visibility back into a two-way bound `@isShown`.
  // That echo makes it show a shown tooltip again and hide a hidden one again,
  // so `onShow` and `onHide` fire twice.
  _hideTooltip(): void {
    if (this.isOpen) {
      super._hideTooltip();
    }
  }

  _showTooltip(): void {
    if (!this.isOpen) {
      super._showTooltip();
    }
  }
}
